import "./styles.css";
import { useState } from "react";

export default function App() {
  const [activePage, setActivePage] = useState("about");

  const pages = [
    { key: "about", label: "关于我们" },
    { key: "services", label: "服务内容" },
    { key: "advantages", label: "核心优势" },
    { key: "contact", label: "联系我们" },
  ];

  return (
    <div className="site">
      <div className="bg-glow"></div>
      <div className="bg-grid"></div>

      <header className="header">
        <div className="container nav">
          <div className="brand">
            <img src="/logo.png" className="logo" alt="logo" />
            <div>
              <div className="brand-cn">中安大田（厦门）科技有限公司</div>
              <div className="brand-en">ZHONGAN DATIAN · XIAMEN</div>
            </div>
          </div>

          <div className="menu">
            {pages.map((p) => (
              <button
                key={p.key}
                onClick={() => setActivePage(p.key)}
                className={activePage === p.key ? "active" : ""}
              >
                {p.label}
              </button>
            ))}
          </div>
        </div>
      </header>

      <section className="hero">
        <div className="container hero-grid">
          <div className="hero-left">
            <div className="tag">
              BRAIN-COMPUTER INTERFACE · EEG · NEURAL NETWORK
            </div>

            <h1>
              用科技洞察大脑
              <br />
              <span>用数据守护健康</span>
            </h1>

            <p>
              基于脑机接口与EEG技术，将大脑信号转化为可量化的数据，
              构建脑健康与心理健康的数字化管理体系。
            </p>

            <div className="btn-group">
              <button
                onClick={() => setActivePage("contact")}
                className="btn primary"
              >
                立即咨询
              </button>
              <button
                onClick={() => setActivePage("services")}
                className="btn ghost"
              >
                了解服务
              </button>
            </div>
          </div>

          <div className="network">
            {[...Array(12)].map((_, i) => (
              <span key={i} className={`node n${i}`}></span>
            ))}
            {[...Array(6)].map((_, i) => (
              <span key={i} className={`line l${i}`}></span>
            ))}
            <div className="pulse"></div>
          </div>
        </div>
      </section>

      <main className="container content">
        <div className="content-panel">
          {activePage === "about" && (
            <section className="page-section">
              <div className="section-tag">ABOUT US</div>
              <h2>关于我们</h2>
              <p className="lead">
                中安大田（厦门）科技有限公司专注脑机接口技术在脑健康与心理健康领域的应用，
                依托EEG脑电采集、智能分析与数据建模能力，推动健康管理从经验判断走向数据驱动。
              </p>

              <div className="grid-2">
                <div className="card">
                  <h3>技术定位</h3>
                  <p>
                    以脑机接口为技术底座，以EEG为核心数据来源，
                    将看不见的大脑活动转化为可分析、可评估、可管理的数据结果。
                  </p>
                </div>
                <div className="card">
                  <h3>应用方向</h3>
                  <p>
                    聚焦脑健康检测、心理健康评估、个性化干预建议等场景，
                    形成检测、分析、评估、干预的服务闭环。
                  </p>
                </div>
              </div>
            </section>
          )}

          {activePage === "services" && (
            <section className="page-section">
              <div className="section-tag">SERVICES</div>
              <h2>服务内容</h2>

              <div className="grid-3">
                <div className="card">
                  <h3>脑健康检测</h3>
                  <p>
                    基于EEG脑电采集技术，捕捉大脑神经电活动信号，
                    输出多维脑状态评估结果。
                  </p>
                </div>

                <div className="card">
                  <h3>心理健康评估</h3>
                  <p>
                    围绕压力、情绪、专注力、疲劳度等核心维度进行科学分析，
                    为个人与机构提供专业参考。
                  </p>
                </div>

                <div className="card">
                  <h3>个性化干预</h3>
                  <p>
                    依托数据分析与神经反馈逻辑，输出更具针对性的干预建议，
                    提升健康管理效率。
                  </p>
                </div>
              </div>
            </section>
          )}

          {activePage === "advantages" && (
            <section className="page-section">
              <div className="section-tag">ADVANTAGES</div>
              <h2>核心优势</h2>

              <div className="grid-3">
                <div className="card">
                  <h3>脑机接口技术支撑</h3>
                  <p>
                    以脑机接口为核心技术路径，建立面向健康管理场景的数据基础与应用能力。
                  </p>
                </div>

                <div className="card">
                  <h3>EEG采集与分析</h3>
                  <p>
                    通过EEG脑电信号采集与多维分析，
                    提供更客观、更直观的脑状态评估依据。
                  </p>
                </div>

                <div className="card">
                  <h3>神经网络建模</h3>
                  <p>
                    结合智能算法与神经网络分析模型，
                    让检测、评估与干预建议更加精准高效。
                  </p>
                </div>
              </div>
            </section>
          )}

          {activePage === "contact" && (
            <section className="page-section">
              <div className="section-tag">CONTACT US</div>
              <h2>联系我们</h2>

              <div className="contact-box">
                <div className="contact-row">
                  <span className="label">公司名称</span>
                  <span>中安大田（厦门）科技有限公司</span>
                </div>
                <div className="contact-row">
                  <span className="label">地址</span>
                  <span>福建省厦门市集美区B21栋</span>
                </div>
                <div className="contact-row">
                  <span className="label">电话</span>
                  <span>18965472890</span>
                </div>
                <div className="contact-row">
                  <span className="label">商务咨询</span>
                  <span>欢迎来电咨询与合作洽谈</span>
                </div>
              </div>
            </section>
          )}
        </div>
      </main>
    </div>
  );
}
